import { defineStore } from "pinia";
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
// import { ElNotification } from "element-plus";

export const useOverlayStore = defineStore("OverlayStore", {
  state: () => ({
    visibleSupport: false,
    isVisible: false,
    showProductDetailpage: false,
    IsError: false,
    ErrorText: "",
    showProductPage: false,
    showLoading: false,
    closeModel: false,
    ConfirmClose: false,
    isModelVisible: false,
    onCloseExit: true,
    confirmCloseCalled: false,
    IsconfirmCloseCalled: false,
    confirmType: "",
    showShortcodeError: false,
    onceHiddenError: false,
  }),
  getters: {
    getError(state) {
      return state.IsError;
    },
    getErrorText(state) {
      return state.ErrorText;
    },
    getConfirmClose(state) {
      return state.ConfirmClose;
    },
    getconfirmCloseCalled(state) {
      return state.confirmCloseCalled;
    },
    getConfirmType(state) {
      return state.confirmType;
    },
    getshowShortcodeError(state) {
      return state.showShortcodeError;
    },
  },
  actions: {
    disableHandleError() {
      this.onceHiddenError = true;
    },
    enableHandleError() {
      this.onceHiddenError = false;
    },
    openOverlay() {
      this.isVisible = true;
    },
    closeOverlay() {
      this.isVisible = false;
      this.showProductDetailpage = false;
      this.IsError = false;
    },
    toggleOverlay() {
      const additionalAttrStore = useAdditionalAttrStore();
      this.showProductDetailpage = additionalAttrStore.getIds.length === 1;
      this.isVisible = !this.isVisible;
      if (this.isVisible) {
        const handleEvent = new CustomEvent("loginIntoConfigurator", {
          bubbles: true,
          detail: true,
        });
        document.dispatchEvent(handleEvent);
      }
    },
    toggleModelOverlay() {
      this.isModelVisible = !this.isModelVisible;
    },
    setError(errorText: string, onCloseExit?: boolean) {
      if (onCloseExit === undefined) onCloseExit = true;
      this.IsError = true;
      this.ErrorText = errorText;
      this.onCloseExit = onCloseExit;
    },
    setShowProductPage() {
      this.showProductDetailpage = true;
    },
    closeloading() {
      this.showLoading = false;
    },
    showVisibleSupport() {
      this.visibleSupport = true;
    },
    closeVisibleSupport() {
      this.visibleSupport = false;
    },
    closeError() {
      this.IsError = false;
    },
    setConfirmClose(
      value: boolean,
      type?: string,
      IsconfirmCloseCalled?: boolean
    ) {
      if (type) {
        this.confirmType = type;
      }

      if (IsconfirmCloseCalled) {
        this.IsconfirmCloseCalled = true;
      }
      this.ConfirmClose = value;
    },
    setconfirmCloseCalled(value: boolean) {
      this.confirmCloseCalled = value;
    },
    setshowShortcodeError(value: boolean) {
      this.showShortcodeError = value;
    },
  },
});
